import { useState } from "react";
import { useNavigate } from "react-router-dom";

import Header from "../../components/Header.js";
import BackButton from "../../components/BackButton";
import Button from "../../components/Button.js";
import Upload, { type UploadFile } from "../../components/Upload";
import SelectedFilesPreview from "./SelectedFilesPreview"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import { toast, type ToastOptions } from "react-toastify";

import BulkUploadService from "../../services/bulk-upload.service.js";

function useHazardsImportDataPage() {
  const [hazardFiles, setHazardFiles] = useState<UploadFile[]>([]);
  let navigate = useNavigate();

  function removeFileByName(fileName: string) {
    const maybeFile = hazardFiles.find(f => f.file.name === fileName);
    if (maybeFile === undefined) {
      return;
    }

    URL.revokeObjectURL(maybeFile.previewUrl);
    setHazardFiles(files => files.filter(f => f.file.name !== fileName));
  }

  function downloadHazardsTemplate() {
    BulkUploadService.hazardsTemplate()
      .then((response) => {
        const url = response.data.s3url;
        const link = document.createElement("a");
        const filename = response.data.filename;
        link.href = url;
        link.setAttribute("download", filename); //or any other extension
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch((error) => console.log(error));
  };

  const notificationSettings: ToastOptions = {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
  };

  function uploadHazards() {
    let uploadFile = hazardFiles[0];
    if (uploadFile === undefined) {
      return;
    }

    BulkUploadService.hazards({ file: uploadFile.file })
      .then((response) => {
        console.log(response);
        toast.success(`The system is uploading your file for processing. Please check your email shortly for more information.`, notificationSettings);
        removeFileByName(uploadFile.file.name);
        navigate("/dataManagementDash");
      })
      .catch((error) => {
        const maybeMessage = error?.response?.data?.apierror?.message;
        if (maybeMessage !== undefined) {
          toast.error(maybeMessage, notificationSettings);
        } else {
          toast.error(`The system was unable to process your file.`, notificationSettings);
        }
      });
  };

  return { hazardFiles, setHazardFiles, uploadHazards, removeFileByName, downloadHazardsTemplate };
}

interface HazardImportDataPageProps {
  setPage: unknown;
}

function HazardsImportDataPage(props: HazardImportDataPageProps) {
  const { hazardFiles, setHazardFiles, uploadHazards, removeFileByName, downloadHazardsTemplate } = useHazardsImportDataPage();

  return (
    <div className="page" id="dataManagementPage">
      <Header title="Bulk Hazards Import" />
      <BackButton setPage={props.setPage} target={["adminDashPage", "backward"]} />

      <h2>Bulk Hazards Import</h2>

      <div className="bulk-upload">
        <Button action="secondary" label="Download Bulk Upload Template for Hazards" onClick={downloadHazardsTemplate}>
          <FontAwesomeIcon icon={faDownload} className="button__icon" />
        </Button>

        {hazardFiles.length > 0 ? (
          <Button action="primary" label="Confirm and upload hazards" onClick={uploadHazards} />
        ) : (
          <Upload
            name="uploadHazards"
            label="Bulk Upload Hazards"
            setFiles={setHazardFiles}
            files={hazardFiles}
            disabled={false}
            camera={false}
            documents={[]}
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" />
        )}

        <SelectedFilesPreview uploadFiles={hazardFiles} removeFileWithName={removeFileByName} />
      </div>
    </div>
  )
}

export default HazardsImportDataPage;
